// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Service.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { APP } from '../../../../../com/MetaPattern/MDA/MD/Base/APP';
import { Unit } from '../../../../../com/MetaPattern/APP/MDA/ModelLib/Unit';
import { UnitBizType } from '../../../../../com/MetaPattern/APP/MDA/ModelLib/UnitBizType';
import { UnitInfoDTO } from '../../../../../com/MetaPattern/APP/MDA/ModelLib/UnitInfoDTO';
import { post, get } from '../../../../../../libs/com/MetaPattern/Product/IDE/Util/Request';
class UseAPPDTO {
  sourceAPPId: string;
  workScopeId: string;
  aPPKey: string;
  gitUrl: string;
  gitBranchName: string;
  gitUsername: string;
  gitPassword: string;

  public toJson(): any {
    const json: any = {};
    json.SourceAPPId = this.sourceAPPId;
    json.WorkScopeId = this.workScopeId;
    json.APPKey = this.aPPKey;
    json.GitUrl = this.gitUrl;
    json.GitBranchName = this.gitBranchName;
    json.GitUsername = this.gitUsername;
    json.GitPassword = this.gitPassword;
    return json;
  }
}
class PublishUnitDTO {
  unit: Unit;

  public toJson(): any {
    const json: any = {};
    if (this.unit.toJson) {
      json.Unit = this.unit.toJson();
    } else {
      json.Unit = this.unit;
    }
    return json;
  }
}
/**
 * 模型库服务 服务类
 * 模型库服务
 */
export class ModelLibService {
  static async UseAPPAsync(sourceAPPId: string, workScopeId: string, aPPKey: string, gitUrl: string, gitBranchName: string, gitUsername: string, gitPassword: string): Promise<APP | null> {
    return new Promise((resolve, reject) => {
      const dto = new UseAPPDTO();
      dto.sourceAPPId = sourceAPPId;
      dto.workScopeId = workScopeId;
      dto.aPPKey = aPPKey;
      dto.gitUrl = gitUrl;
      dto.gitBranchName = gitBranchName;
      dto.gitUsername = gitUsername;
      dto.gitPassword = gitPassword;
      post('metapattern-ide-mda/service/modellibservice/useapp', dto.toJson())
        .then((response: any) => {
          let result: APP | null = null;
          if (response) {
            result = APP.Create(response);
          }
          resolve(result);
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }

  static async PublishUnitAsync(unit: Unit): Promise<Unit | null> {
    return new Promise((resolve, reject) => {
      const dto = new PublishUnitDTO();
      dto.unit = unit;
      post('metapattern-ide-mda/service/modellibservice/publishunit', dto.toJson())
        .then((response: any) => {
          let result: Unit | null = null;
          if (response) {
            result = Unit.Create(response);
            if (response.BizType !== null) {
              result.bizType = UnitBizType.Create(response.BizType);
            }
          }
          resolve(result);
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }

  static async GetUnitAsync(id: string, aPPId: string, productId: string): Promise<Unit | null> {
    return new Promise((resolve, reject) => {
      get('metapattern-ide-mda/service/modellibservice/getunit', { id: id, aPPId: aPPId, productId: productId })
        .then((response: any) => {
          let result: Unit | null = null;
          if (response) {
            result = Unit.Create(response);
            if (response.BizType !== null) {
              result.bizType = UnitBizType.Create(response.BizType);
            }
          }
          resolve(result);
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }

  static async GetUnitPageAsync(pageNo: number, pageSize: number): Promise<Array<UnitInfoDTO> | null> {
    return new Promise((resolve, reject) => {
      get('metapattern-ide-mda/service/modellibservice/getunitpage', { pageNo: pageNo, pageSize: pageSize })
        .then((response: any) => {
          let result: Array<UnitInfoDTO> | null = null;
          if (response) {
            const items = new Array<UnitInfoDTO>();
            response.forEach((item: any) => {
              const element = UnitInfoDTO.Create(item);
              items.push(element);
            });
            result = items;
          }
          resolve(result);
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }

  static async GetAPPInfoAsync(id: string): Promise<APP | null> {
    return new Promise((resolve, reject) => {
      get('metapattern-ide-mda/service/modellibservice/getappinfo', { id: id })
        .then((response: any) => {
          let result: APP | null = null;
          if (response) {
            result = APP.Create(response);
          }
          resolve(result);
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }
}
